import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useSelectedBusinessUnit } from 'contexts/SidebarContext';
import type React from 'react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MOBILE_PAGE_PT, NAVY, RADIUS_COIN, SURFACE_CONTAINER_LOW, YELLOW } from 'styles/tokens';

import LeadsDashboard from './components/LeadsDashboard';

const Dashboard: React.FC = () => {
  const { selectedBusinessUnitId: businessUnitId, setSelectedBusinessUnitId } = useSelectedBusinessUnit();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paramId = searchParams.get('businessUnitId');
    if (paramId) {
      const parsed = Number.parseInt(paramId, 10);
      if (!Number.isNaN(parsed)) setSelectedBusinessUnitId(parsed);
    }
    // Only run on mount — intentionally omitting deps
  }, []);

  const hasBusinessUnit = businessUnitId !== null && businessUnitId !== -1;

  return (
    <Box sx={{ px: { xs: 2, lg: 4 }, pt: { xs: `${MOBILE_PAGE_PT}px`, md: 3 }, pb: 6 }}>
      {hasBusinessUnit ? (
        <LeadsDashboard businessUnitId={businessUnitId} />
      ) : (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 'calc(100vh - 160px)',
            textAlign: 'center',
            backgroundColor: SURFACE_CONTAINER_LOW,
            borderRadius: RADIUS_COIN,
            px: 3,
            py: { xs: 6, md: 10 },
            overflow: 'hidden',
          }}
        >
          {/* Decorative yellow disc — the "moneda" isotipo nod */}
          <Box
            aria-hidden
            sx={{
              position: 'absolute',
              top: -160,
              right: -160,
              width: 420,
              height: 420,
              borderRadius: '50%',
              background: `radial-gradient(circle, ${alpha(YELLOW, 0.22)} 0%, ${alpha(YELLOW, 0)} 70%)`,
            }}
          />

          <Box sx={{ position: 'relative', maxWidth: 520 }}>
            <Typography
              sx={{
                fontFamily: 'Jost, sans-serif',
                fontWeight: 600,
                fontSize: '0.75rem',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: alpha(NAVY, 0.5),
                mb: 1,
              }}
            >
              Dashboard
            </Typography>
            <Typography
              component="h1"
              sx={{
                fontFamily: 'Jost, sans-serif',
                fontWeight: 800,
                fontSize: { xs: '1.6rem', md: '2.15rem' },
                lineHeight: 1.15,
                color: NAVY,
                letterSpacing: '-0.02em',
                mb: 1.5,
              }}
            >
              Selecciona una unidad de negocio para ver el flujo
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Jost, sans-serif',
                fontSize: '1rem',
                color: alpha(NAVY, 0.6),
                lineHeight: 1.5,
              }}
            >
              Elige una unidad de negocio en la barra lateral para visualizar el embudo de leads, las tasas de contacto
              y respuesta, y las métricas de envío al CRM.
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
